<template>
	<nav class="menunavleftbar ownmenu">
        <ul class="nav">
            <!-- MEGA MENU -->
            <li><a href="/contact">Tour Markets</a> </li>
            <li><a href="/create">Create A Sellpoint</a></li>
            <li class="dropdown" v-if="loggedIn"><a href="#" role="button" ><i class="icon-user"></i> </a>
                <ul class="dropdown-content">
                    <li><h6>Hello! {{user}}</h6></li>
                    <li><a href="/cart">My Cart</a></li>
                    <li><a href="/account">Account</a></li>
                    <li><a href="/login">Log Out</a></li>
                </ul>
            </li>
            <li v-else><a href="/login">Log In</a> </li>
            
                  
        </ul>
    </nav>
</template>
<style>
/* nav{
    padding-right: 20em;
} */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    padding: 7px 6px;
    border: 1px solid #bfc1c3;
    border-top: none;
    /* padding: 25px 20px; */
    border-radius: 0px 0px 8px 8px;
    text-transform: capitalize;
    line-height: 1.2;
}
.dropdown-content li{
    line-height: 1.8;
    margin-left: 1em;
    margin-right: 1em;
}

.dropdown:hover .dropdown-content {
  display:block;
}
</style>
<script>
import services from './../services/service'; // Service Class
let service = new services();

export default {
   name: 'MenuLeftBar',
    
    data () {
        return {
           user:{},
           loggedIn:false,
        }
    },
    methods: {
        checkLoggedIn(){
            if(localStorage.getItem("sp_token") != null){
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
    },
  
    created(){
        this.checkLoggedIn()
    }
}
</script>


// WEBPACK FOOTER //
// menuleftbar.vue?f4ee20cc